import BookingForm from './booking_form';

export default BookingForm;
